import { render, staticRenderFns } from "./Sprostredkovatel.vue?vue&type=template&id=2ed57232&"
import script from "./Sprostredkovatel.vue?vue&type=script&lang=js&"
export * from "./Sprostredkovatel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ed57232')) {
      api.createRecord('2ed57232', component.options)
    } else {
      api.reload('2ed57232', component.options)
    }
    module.hot.accept("./Sprostredkovatel.vue?vue&type=template&id=2ed57232&", function () {
      api.rerender('2ed57232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/basic/Sprostredkovatel.vue"
export default component.exports